export default __webpack_public_path__ + "app/images/bg-linshare-desktop.png";